import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type ModeState = "dark" | "light";

export type SiteState = {
    mode: ModeState;
    sideNavOpened: boolean;
    isLoggedIn: boolean;
};

const initialState: SiteState = {
    mode: "light",
    sideNavOpened: false,
    isLoggedIn: false
};

export const siteSlice = createSlice({
    name: "site",
    initialState,
    reducers: {
        changeMode: (state, action: PayloadAction<ModeState>) => {
            state.mode = action.payload;
        },
        openSideNav: (state) => {
            state.sideNavOpened = true;
        },
        closeSideNav: (state) => {
            state.sideNavOpened = false;
        },
        logUserIn: (state) => {
            state.isLoggedIn = true;
        },
        logUserOut: (state) => {
            state.isLoggedIn = false;
        }
    }
});

export const { changeMode, openSideNav, closeSideNav, logUserIn, logUserOut } =
    siteSlice.actions;

export default siteSlice.reducer;
